import { createContext, useState } from "react";

export const UserContext = createContext({});

export function UserContextProvider({ children }) {
    const [userInfo, setUserInfo] = useState({});
    return (
        <UserContext.Provider value={{ userInfo, setUserInfo }}>
            {children}
        </UserContext.Provider>
    );
}


//codigo viejo


// import { createContext, useState } from "react";

// export const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//     const [userInfo, setUserInfo] = useState(null);

//     return (
//         <UserContext.Provider value={{ userInfo, setUserInfo }}>
//             {children}
//         </UserContext.Provider>
//     );
// };